/* Ellmin — comportements des sections sur mesure. Aucun framework, chargé en différé. */
(() => {
  const formatMoney = (cents, format) => {
    const value = (cents / 100);
    const withSep = (n, dec, thousands, decimal) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return (format || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return withSep(value, 2, ',', '.');
        case 'amount_no_decimals': return withSep(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return withSep(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSep(value, 2, "'", '.');
        case 'amount_with_space_separator': return withSep(value, 2, ' ', ',');
        default: return withSep(value, 2, '.', ',');
      }
    });
  };

  const escapeHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------------- Fiche produit ---------------- */
  if (!customElements.get('ell-product')) {
    customElements.define('ell-product', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-ell-variants]').textContent);
        this.money = JSON.parse(this.querySelector('[data-ell-money]').textContent);
        this.form = document.getElementById(this.dataset.form);
        this.variantInput = this.querySelector('[data-ell-variant-input]');
        this.qtyInput = this.querySelector('[data-ell-qty]');
        this.current = this.variants.find((v) => this.variantInput && v.id === Number(this.variantInput.value)) || this.variants[0];
        this.tierBox = this.querySelector('[data-ell-tiers]');
        this.tiers = [...this.querySelectorAll('[data-ell-tiers] input[type="radio"]')];
        this.tiers.forEach((r) => r.addEventListener('change', () => this.render()));
        // Arrivée depuis l'accueil avec ?offre=N : cette offre est cochée.
        const offre = new URLSearchParams(window.location.search).get('offre');
        if (offre) { const r = this.tiers.find((x) => x.dataset.tier === offre); if (r) r.checked = true; }
        this.querySelectorAll('[data-ell-addon]').forEach((box) => {
          const pick = box.querySelector('[data-ell-addon-variant]');
          const check = box.querySelector('[data-ell-addon-check]');
          const img = box.querySelector('.ell-addon__img img');
          box.classList.toggle('is-on', check.checked);
          check.addEventListener('change', () => { box.classList.toggle('is-on', check.checked); this.render(); });
          if (pick && pick.tagName === 'SELECT') pick.addEventListener('change', () => {
            check.checked = true;
            box.classList.add('is-on');
            const o = pick.selectedOptions[0];
            if (img && o && o.dataset.img) { img.removeAttribute('srcset'); img.src = o.dataset.img; }
            this.render();
          });
        });
        this.querySelectorAll('[data-ell-extra-variant]').forEach((sel) => sel.addEventListener('change', () => {
          const o = sel.selectedOptions[0];
          const img = sel.closest('[data-tier-card]').querySelector('[data-ell-extra-img] img');
          if (img && o && o.dataset.img) { img.removeAttribute('srcset'); img.src = o.dataset.img; }
          this.render();
        }));
        this.querySelectorAll('[data-ell-unit]').forEach((sel) => sel.addEventListener('change', () => {
          const v = this.byId(sel.value);
          if (v) { this.current = v; this.renderStock(); this.goToMedia(v.media); }
          this.renderTierImage(sel);
          this.render();
        }));
        // Avec des offres, l'ajout au panier passe par /cart/add.js (plusieurs variantes, article ajouté).
        this.addEventListener('submit', (e) => {
          if (!this.tiers.length || !this.form || e.target !== this.form) return;
          e.preventDefault();
          e.stopPropagation();
          this.addToCart();
        }, true);
        this.initGallery();
        this.initOptions();
        this.initDelivery();
        this.initSticky();
        this.render();
      }

      /* Galerie : compteur, miniatures, défilement vers la photo de la variante */
      initGallery() {
        this.track = this.querySelector('[data-ell-track]');
        if (!this.track) return;
        this.slides = [...this.track.children];
        this.indexEl = this.querySelector('[data-ell-index]');
        this.thumbs = [...this.querySelectorAll('[data-ell-thumb]')];
        let ticking = false;
        this.track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            this.setActive(i);
            ticking = false;
          });
        }, { passive: true });
        this.thumbs.forEach((btn) => btn.addEventListener('click', () => this.goTo(Number(btn.dataset.ellThumb))));
        this.querySelectorAll('[data-ell-step]').forEach((btn) => btn.addEventListener('click', () => {
          const n = this.slides.length;
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.goTo((i + Number(btn.dataset.ellStep) + n) % n);
        }));
        this.track.addEventListener('keydown', (e) => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(Math.min(i + 1, this.slides.length - 1)); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(Math.max(i - 1, 0)); }
        });
      }
      setActive(i) {
        if (this.indexEl) this.indexEl.textContent = i + 1;
        this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
        const active = this.thumbs[i];
        if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      goTo(i) {
        if (!this.track || !this.slides[i]) return;
        this.track.scrollTo({ left: this.slides[i].offsetLeft, behavior: 'smooth' });
        this.setActive(i);
      }
      goToMedia(mediaId) {
        if (!mediaId || !this.slides) return;
        const i = this.slides.findIndex((s) => Number(s.dataset.mediaId) === mediaId);
        if (i >= 0) this.goTo(i);
      }

      /* Choix de variante */
      initOptions() {
        this.optionButtons = [...this.querySelectorAll('[data-ell-option]')];
        if (!this.optionButtons.length) return;
        this.selected = [...this.current.options];
        this.optionButtons.forEach((btn) => btn.addEventListener('click', () => {
          const pos = Number(btn.dataset.ellOption);
          this.selected[pos] = btn.dataset.value;
          const match = this.variants.find((v) => v.options.every((o, n) => o === this.selected[n]));
          if (match) this.setVariant(match);
          this.renderOptions();
        }));
        this.renderOptions();
      }
      renderOptions() {
        this.optionButtons.forEach((btn) => {
          const pos = Number(btn.dataset.ellOption);
          btn.setAttribute('aria-pressed', String(this.selected[pos] === btn.dataset.value));
          const test = [...this.selected];
          test[pos] = btn.dataset.value;
          const v = this.variants.find((x) => x.options.every((o, n) => o === test[n]));
          btn.classList.toggle('is-unavailable', !v || !v.available);
        });
        this.querySelectorAll('[data-ell-selected]').forEach((el) => {
          el.textContent = this.selected[Number(el.dataset.ellSelected)] || '';
        });
      }
      setVariant(v) {
        this.current = v;
        if (this.variantInput) this.variantInput.value = v.id;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        this.render();
        this.renderButton();
        this.renderStock();
        this.goToMedia(v.media);
      }

      /* Photo de la carte d'offre : celle de la couleur choisie dans le premier menu de la carte */
      renderTierImage(sel) {
        const card = sel.closest('[data-tier-card]');
        if (!card) return;
        const first = card.querySelector('[data-ell-unit]');
        const opt = first && first.selectedOptions[0];
        const img = card.querySelector('.ell-bundle__img img, .ell-bundle__pair-a img');
        if (!img || !opt || !opt.dataset.img) return;
        img.removeAttribute('srcset');
        img.src = opt.dataset.img;
      }

      /* Offre cochée : quantité, remise et rang (99 = pas de cartes d'offres) */
      tier() {
        const r = this.tiers.find((x) => x.checked);
        if (!r) return { qty: 1, disc: 0, index: 99 };
        return { qty: Number(r.value), disc: Number(r.dataset.discount), index: Number(r.dataset.tier) };
      }
      byId(id) {
        return this.variants.find((v) => v.id === Number(id));
      }
      totals(qty, disc) {
        const v = this.current;
        const now = Math.round((v.price * qty * (100 - disc)) / 100);
        const ref = (v.compare > v.price ? v.compare : v.price) * qty;
        return { now, ref, save: ref - now };
      }
      tierTotals(r) {
        const selects = [...r.closest('[data-tier-card]').querySelectorAll('[data-ell-unit]')];
        let price = 0;
        let ref = 0;
        if (selects.length) {
          selects.forEach((sel) => {
            const v = this.byId(sel.value) || this.current;
            price += v.price;
            ref += v.compare > v.price ? v.compare : v.price;
          });
        } else {
          const v = this.current;
          price = v.price * Number(r.value);
          ref = (v.compare > v.price ? v.compare : v.price) * Number(r.value);
        }
        let now = Math.round((price * (100 - (Number(r.dataset.discount) || 0))) / 100);
        if (r.dataset.extraId) {
          const exSel = r.closest('[data-tier-card]').querySelector('[data-ell-extra-variant]');
          const exOpt = exSel && exSel.selectedOptions[0];
          const exPrice = exOpt ? Number(exOpt.dataset.price) : Number(r.dataset.extraPrice);
          const exCompare = exOpt ? Number(exOpt.dataset.compare) : Number(r.dataset.extraCompare || r.dataset.extraPrice);
          const extra = (exPrice || 0) * (Number(r.dataset.extraQty) || 0);
          const extraRef = (exCompare || exPrice || 0) * (Number(r.dataset.extraQty) || 0);
          now += Math.round((extra * (100 - (Number(r.dataset.extraDisc) || 0))) / 100);
          ref += extraRef;
        }
        return { now, ref, save: ref - now };
      }
      cartItems() {
        const r = this.tiers.find((x) => x.checked) || this.tiers[0];
        const counts = new Map();
        const selects = [...r.closest('[data-tier-card]').querySelectorAll('[data-ell-unit]')];
        if (selects.length) selects.forEach((sel) => counts.set(sel.value, (counts.get(sel.value) || 0) + 1));
        else counts.set(String(this.current.id), Number(r.value));
        const items = [...counts].map(([id, quantity]) => ({ id: Number(id), quantity }));
        if (r.dataset.extraId) {
          const exSel = r.closest('[data-tier-card]').querySelector('[data-ell-extra-variant]');
          items.push({ id: Number(exSel ? exSel.value : r.dataset.extraId), quantity: Number(r.dataset.extraQty) || 1 });
        }
        // Produits en complément cochés (ex. flexible assorti) : une pièce chacun, couleur choisie.
        this.querySelectorAll('[data-ell-addon]').forEach((box) => {
          const check = box.querySelector('[data-ell-addon-check]');
          const pick = box.querySelector('[data-ell-addon-variant]');
          if (check && check.checked && pick) items.push({ id: Number(pick.value), quantity: 1 });
        });
        return items;
      }
      async addToCart() {
        const btn = this.querySelector('[data-ell-add]');
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
        const wrap = this.querySelector('.product-form__error-message-wrapper');
        const spinner = btn.querySelector('.loading__spinner');
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
        if (wrap) wrap.hidden = true;
        const body = { items: this.cartItems() };
        if (cart && cart.getSectionsToRender) {
          body.sections = cart.getSectionsToRender().map((sec) => sec.id);
          body.sections_url = window.location.pathname;
        }
        const root = (window.routes && window.routes.cart_add_url) || '/cart/add';
        try {
          const res = await fetch(`${root}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body),
          });
          const data = await res.json();
          if (!res.ok || data.status) {
            if (wrap) {
              wrap.querySelector('.product-form__error-message').textContent = data.description || data.message || 'Ajout impossible, réessayez.';
              wrap.hidden = false;
            }
            return;
          }
          if (!cart || !cart.renderContents) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          const first = data.items && data.items[0];
          cart.renderContents(Object.assign({}, first || {}, { sections: data.sections }));
          // publish et PUB_SUB_EVENTS sont des globales de Dawn (pubsub.js, constants.js).
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: first && first.variant_id, cartData: data });
          }
        } catch (err) {
          if (wrap) {
            wrap.querySelector('.product-form__error-message').textContent = 'Ajout impossible, vérifiez votre connexion.';
            wrap.hidden = false;
          }
        } finally {
          btn.classList.remove('loading');
          btn.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      }

      /* Prix, bouton, barre collante, cartes d'offres et cadeaux suivent l'offre et la variante */
      render() {
        const m = (cents) => formatMoney(cents, this.money);
        const t = this.tier();
        const checked = this.tiers.find((x) => x.checked);
        const tot = checked ? this.tierTotals(checked) : this.totals(t.qty, t.disc);
        // Produits en complément cochés : leur prix s'ajoute au prix affiché et au bouton.
        const addons = this.addonTotal();
        tot.now += addons;
        tot.ref += addons;
        if (this.qtyInput) this.qtyInput.value = t.qty;
        this.querySelectorAll('[data-ell-price], [data-ell-sticky-price], [data-ell-pill-now]').forEach((el) => { el.textContent = m(tot.now); });
        this.renderSticky(checked, tot, m);
        this.querySelectorAll('[data-ell-compare], [data-ell-pill-was]').forEach((el) => {
          el.hidden = tot.ref <= tot.now;
          el.textContent = m(tot.ref);
        });
        this.querySelectorAll('[data-ell-save]').forEach((el) => {
          el.hidden = tot.save <= 0;
          if (tot.save <= 0) return;
          const eco = el.dataset.mode === 'percent' ? `${Math.round((tot.save * 100) / tot.ref)} %` : m(tot.save);
          el.textContent = el.dataset.template.replace('[eco]', eco);
        });
        const saveTemplate = this.tierBox ? this.tierBox.dataset.saveTemplate || '' : '';
        this.tiers.forEach((r) => {
          const x = this.tierTotals(r);
          const box = r.closest('[data-tier-card]');
          box.classList.toggle('is-selected', r.checked);
          const total = box.querySelector('[data-ell-tier-total]');
          const full = box.querySelector('[data-ell-tier-full]');
          const save = box.querySelector('[data-ell-tier-save]');
          if (total) total.textContent = m(x.now);
          if (full) { full.hidden = x.ref <= x.now; full.textContent = m(x.ref); }
          if (save) { save.hidden = x.save <= 0; save.textContent = saveTemplate.replace('[eco]', m(x.save)); }
        });
        this.querySelectorAll('[data-unlock]').forEach((li) => {
          li.classList.toggle('is-locked', Number(li.dataset.unlock) > t.index);
        });
      }
      /* Barre collante : offre cochée, couleur choisie, photo de la couleur, prix barré */
      renderSticky(checked, tot, m) {
        const bar = this.querySelector('[data-ell-sticky]');
        if (!bar) return;
        const was = bar.querySelector('[data-ell-sticky-was]');
        if (was) { was.hidden = tot.ref <= tot.now; was.textContent = m(tot.ref); }
        const label = bar.querySelector('[data-ell-sticky-label]');
        const img = bar.querySelector('.ell-sticky__img');
        const card = checked && checked.closest('[data-tier-card]');
        const selects = card ? [...card.querySelectorAll('[data-ell-unit]')] : [];
        const opts = selects.map((s) => s.selectedOptions[0]).filter(Boolean);
        const colours = [...new Set(opts.map((o) => o.textContent.trim()))];
        const name = card ? (card.querySelector('.ell-bundle__label') || {}).textContent : '';
        if (label) {
          const parts = [];
          if (name) parts.push(name.trim());
          if (colours.length === 1) parts.push(colours[0]);
          else if (colours.length > 1) parts.push(`${colours.length} couleurs`);
          label.textContent = parts.length ? parts.join(' · ') : (this.current.title || '');
        }
        const src = opts[0] && opts[0].dataset.img;
        if (img && src && img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.src = src; }
      }
      addonTotal() {
        let sum = 0;
        this.querySelectorAll('[data-ell-addon]').forEach((box) => {
          const check = box.querySelector('[data-ell-addon-check]');
          const pick = box.querySelector('[data-ell-addon-variant]');
          if (!check || !check.checked || !pick) return;
          const src = pick.tagName === 'SELECT' ? pick.selectedOptions[0] : pick;
          sum += Number(src && src.dataset.price) || 0;
        });
        return sum;
      }
      renderButton() {
        const btn = this.querySelector('[data-ell-add]');
        if (!btn) return;
        const label = btn.querySelector('.ell-buy__label');
        btn.disabled = !this.current.available;
        if (label) label.textContent = this.current.available ? btn.dataset.label : btn.dataset.soldout;
      }
      renderStock() {
        const el = this.querySelector('[data-ell-stock]');
        if (!el) return;
        const inv = this.current.inv;
        const threshold = Number(el.dataset.threshold);
        const show = inv !== null && inv > 0 && inv <= threshold;
        el.hidden = !show;
        if (show) el.querySelector('[data-ell-stock-text]').textContent = el.dataset.template.replace('[n]', inv);
      }

      /* Date de livraison estimée, dates en gras */
      initDelivery() {
        const el = this.querySelector('[data-ell-delivery]');
        if (!el) return;
        const skip = el.dataset.skipWeekends === 'true';
        const add = (days) => {
          const d = new Date();
          let left = days;
          while (left > 0) {
            d.setDate(d.getDate() + 1);
            const day = d.getDay();
            if (!skip || (day !== 0 && day !== 6)) left -= 1;
          }
          return d;
        };
        const fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
        const html = escapeHtml(el.dataset.template)
          .replace('[debut]', `<strong>${escapeHtml(fmt.format(add(Number(el.dataset.min))))}</strong>`)
          .replace('[fin]', `<strong>${escapeHtml(fmt.format(add(Number(el.dataset.max))))}</strong>`);
        el.querySelector('[data-ell-delivery-text]').innerHTML = html;
      }

      /* Barre d'achat collante */
      initSticky() {
        this.sticky = this.querySelector('[data-ell-sticky]');
        const mainBtn = this.querySelector('[data-ell-add]');
        if (!this.sticky || !mainBtn || !('IntersectionObserver' in window)) return;
        const stickyBtn = this.sticky.querySelector('[data-ell-sticky-add]');
        const observer = new IntersectionObserver(([entry]) => {
          const below = entry.boundingClientRect.top < 0;
          const show = !entry.isIntersecting && below;
          this.sticky.classList.toggle('is-visible', show);
          this.sticky.setAttribute('aria-hidden', String(!show));
          stickyBtn.tabIndex = show ? 0 : -1;
        });
        observer.observe(mainBtn);
        stickyBtn.addEventListener('click', () => {
          if (mainBtn.disabled) { mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          if (this.form && this.form.requestSubmit) this.form.requestSubmit(mainBtn);
          else mainBtn.click();
        });
      }
    });
  }

  /* ---------------- Calculateur d'économie ---------------- */
  if (!customElements.get('ell-calc')) {
    customElements.define('ell-calc', class extends HTMLElement {
      connectedCallback() {
        this.cfg = JSON.parse(this.querySelector('[data-ell-calc-config]').textContent);
        this.money = this.cfg.money;
        this.inputs = [...this.querySelectorAll('[data-ell-in]')];
        this.inputs.forEach((i) => i.addEventListener('input', () => this.update()));
        this.querySelectorAll('[data-ell-step]').forEach((b) => b.addEventListener('click', () => {
          const input = this.querySelector(`[data-ell-in="${b.dataset.target}"]`);
          const next = Number(input.value) + Number(b.dataset.ellStep);
          input.value = Math.min(Number(input.max), Math.max(Number(input.min), next));
          this.update();
        }));
        this.update();
      }
      val(name) {
        const el = this.querySelector(`[data-ell-in="${name}"]`);
        return el ? Number(String(el.value).replace(',', '.')) : 0;
      }
      update() {
        const people = this.val('people');
        const minutes = this.val('minutes');
        const oldFlow = this.val('flow');
        const heater = this.querySelector('[data-ell-in="heater"]').value;
        const water = this.val('water') || this.cfg.water;
        const newFlow = this.cfg.flow;
        const minutesOut = this.querySelector('[data-ell-out="minutes"]');
        if (minutesOut) minutesOut.textContent = minutes;
        const saved = Math.max(0, oldFlow - newFlow) * minutes * people * 365; // litres par an
        const m3 = saved / 1000;
        const kwh = { elec: this.cfg.kwhElec, gaz: this.cfg.kwhGas, pac: this.cfg.kwhPac, inconnu: this.cfg.kwhGas }[heater] || 0;
        const energyPrice = heater === 'elec' || heater === 'pac' ? this.cfg.priceElec : this.cfg.priceGas;
        const euros = m3 * water + m3 * kwh * energyPrice;
        const weeks = euros > 0 ? Math.ceil(this.cfg.price / 100 / (euros / 52)) : null;
        this.set('litres', Math.round(saved).toLocaleString('fr-FR'));
        this.set('euros', Math.round(euros).toLocaleString('fr-FR'));
        this.set('weeks', weeks ? weeks : '—');
      }
      set(name, value) {
        const el = this.querySelector(`[data-ell-out="${name}"]`);
        if (el) el.textContent = value;
      }
    });
  }
})();

/* Avis défilants : boucle sans à-coup.
   Clone la ligne jusqu'à dépasser deux largeurs d'écran, puis fait glisser exactement
   la largeur d'une copie, à vitesse constante (--ell-speed = secondes pour 1 000 px). */
(() => {
  if (window.ellTickerReady) return;
  window.ellTickerReady = true;

  const setup = (row) => {
    const track = row.querySelector('.ell-ticker__track');
    if (!track) return;
    const groups = track.querySelectorAll('.ell-ticker__group');
    const first = groups[0];
    if (!first) return;
    groups.forEach((g, i) => { if (i > 0) g.remove(); });
    const w = first.getBoundingClientRect().width;
    if (!w) return;
    const need = Math.ceil((row.clientWidth * 2) / w) + 1;
    for (let i = 0; i < need; i++) {
      const clone = first.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }
    const secPer1000 = parseFloat(getComputedStyle(row).getPropertyValue('--ell-speed')) || 20;
    track.style.setProperty('--ell-dist', `${w}px`);
    track.style.animationDuration = `${(w / 1000) * secPer1000}s`;
    track.classList.add('is-ready');
  };

  const init = (root = document) => root.querySelectorAll('.ell-ticker__row').forEach(setup);
  const start = () => {
    init();
    let t;
    let lastW = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      clearTimeout(t);
      t = setTimeout(init, 200);
    });
    document.addEventListener('shopify:section:load', (e) => init(e.target));
    document.addEventListener('shopify:block:select', () => init());
  };
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);
  else window.addEventListener('load', start);
})();

/* Avis : « Lire la suite » seulement quand le texte est vraiment coupé */
(() => {
  if (window.ellMoreReady) return;
  window.ellMoreReady = true;
  const init = (root = document) => root.querySelectorAll('.ell-rv__card').forEach((card) => {
    const t = card.querySelector('[data-ell-clamp]');
    const b = card.querySelector('[data-ell-more]');
    if (!t || !b || b.dataset.ready) return;
    b.dataset.ready = '1';
    if (t.scrollHeight > t.clientHeight + 2) b.hidden = false;
    b.addEventListener('click', () => {
      const open = card.classList.toggle('is-open');
      b.textContent = open ? 'Réduire' : 'Lire la suite';
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* Accueil : carrousel héros (points, défilement automatique qui s'arrête au toucher) */
(() => {
  if (window.ellSliderReady) return;
  window.ellSliderReady = true;
  const init = (root = document) => root.querySelectorAll('[data-ell-slider]').forEach((box) => {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    const track = box.querySelector('[data-ell-slider-track]');
    const dots = [...box.querySelectorAll('[data-ell-slider-dot]')];
    if (!track || dots.length < 2) return;
    const index = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    let tick = false;
    track.addEventListener('scroll', () => {
      if (tick) return;
      tick = true;
      requestAnimationFrame(() => { const i = index(); dots.forEach((d, n) => d.classList.toggle('is-active', n === i)); tick = false; });
    }, { passive: true });
    dots.forEach((d, n) => d.addEventListener('click', () => { stop(); go(n); }));
    const delay = Number(box.dataset.autoplay) * 1000;
    let timer = null;
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = setInterval(() => go((index() + 1) % dots.length), delay);
      ['pointerdown', 'touchstart', 'wheel'].forEach((ev) => track.addEventListener(ev, stop, { passive: true, once: true }));
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
